import React from 'react';

import { FieldArray, FieldArrayRenderProps } from '~src/settings/FormikWrapperForStubbing';

import { DomainTableItem } from '../types/DomainTableItem';
import { PoolID } from '../types/PoolID';
import { DomainTableRow } from './DomainTableRow';

export type DomainTableBodyProps = Readonly<{
    domainItems: ReadonlyArray<DomainTableItem>;
    onEditDomainClicked: (domainId: string) => void;
    onDeleteDomainClicked: (domainId: string, poolId: PoolID) => void;
}>;

export function DomainTableBody(props: DomainTableBodyProps) {
    return (
        <tbody>
            <FieldArray
                name={''}
                render={(_arrayHelpers: FieldArrayRenderProps) => (
                    props.domainItems.map((item: DomainTableItem, index: number) => (
                        renderRow(item, index, props.onEditDomainClicked, props.onDeleteDomainClicked)
                    ))
                )}
            />
        </tbody>
    );
}

function renderRow(
    item: DomainTableItem,
    index: number,
    onEditDomainClicked: (domainId: string) => void,
    onDeleteDomainClicked: (domainId: string, poolId: PoolID) => void,
) {
    const onEditClicked = () => onEditDomainClicked(item.domainId);
    const onDeleteClicked = () => onDeleteDomainClicked(item.domainId, item.poolId as PoolID);

    return (
        <DomainTableRow
            key={index}
            rowIndex={index}
            domainName={item.domainName}
            poolName={item.poolName}
            onEditClicked={onEditClicked}
            onDeleteClicked={onDeleteClicked}
            domainPermission={item.domainPermission}
        />
    );
}